<template>
  <div v-if="hotList.length">
    <h2 class="flex mb-5">
      <span class="text-dark font-semibold text-2xl ">24小时热推榜</span>
      <!-- <div class="ml-2">
        <span class="rounded-full bg-[#F25B3A] font-semibold text-white text-xs px-2 inline-block">
          HOT
        </span>
      </div> -->
    </h2>
    <nuxt-link v-for="(item, index) in hotList" :key="item.no" :class="$style.item" :title="item.title" target="_blank"
      :to="`/company/article/${item.no}`">
      <!-- <v-responsive class="w-full" :aspectRatio="264 / 180"> -->
      <v-responsive class="w-full" :aspectRatio="310 / 206">
        <div class="absolute inset-0" :class="$style.mask">
          <el-image class="absolute inset-0" :style="{ borderRadius: '4px' }" fit="cover" :src="item.cover"
            :alt="item.title" />
          <span :class="$style.itemTag">
            <i class="ficon ficon-hot-fill"></i>
            <span class="-ml-0.5">TOP{{ index + 1 }}</span>
          </span>
          <div :class="$style.itemFooter">
            <h3 :class="$style.itemTitle">{{ item.title }}</h3>
          </div>
        </div>

      </v-responsive>
    </nuxt-link>
  </div>
</template>
<script>
import { ref, onBeforeMount } from "@nuxtjs/composition-api";
import useRequest from "~/composables/useRequest";
// api
import { getHot24Top } from "~/services/company";

import VResponsive from "@/components/VResponsive/VResponsive.vue";
export default {
  components: { VResponsive },
  setup() {
    const { execute, state } = useRequest(getHot24Top, [], {
      immediate: false,
    });

    onBeforeMount(async () => {
      await execute(0);
    });

    // const hotList = ref([{ title: '海洋奇迹号', cover: 'https://static.shangchuanba.com/wechat/242936318/N2a6XvJh3T1xHPI.jpeg_652x652q100.jpg' }])

    return {
      hotList: state,
      // hotList
    };
  },
};
</script>
<style lang="scss" module>
.item {
  display: block;
  position: relative;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0/0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  -webkit-transition-property: -webkit-box-shadow;
  -o-transition-property: box-shadow;
  transition-property: box-shadow, -webkit-box-shadow;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.item ~ * {
  margin-top: 1rem;
}
.item:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0/0.1),0 8px 10px -6px rgb(0 0 0/0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color),0 8px 10px -6px var(--tw-shadow-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
}
.itemFooter {
  background-image: -o-linear-gradient(top, var(--tw-gradient-stops));
  background-image: -webkit-gradient(linear, left top, left bottom, from(var(--tw-gradient-stops)));
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  --tw-gradient-from: transparent;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(255, 255, 255, 0));
  --tw-gradient-to: rgba(31, 31, 31, var(--tw-to-opacity, 1));
  padding: 1rem;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-radius: 4px;
  padding-bottom: 12px;
}
.itemTitle {
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.itemTag {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 87, 79, var(--tw-bg-opacity));
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  position: absolute;
  left: 0px;
  top: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.mask {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.44) 100%);
  border-radius: 4px;
}
</style>